import initRelatedListingsModules from '../../src/relatedListings/relatedListingsModules'
import initDeliverySection from '../../src/deliverySection'
import initfixedDeliverySection from '../../src/fixedDeliverySection'
import { initPDPFomoStats } from '../../src/fomoStats'
import setUpMakeAnOffer from '../../src/makeAnOffer'
import setUpMakeAnOfferOld from '../../src/makeAnOfferOld'
import updateUserSpecificSections from '../../src/userSpecificSections'
import setUpAddToWishlistBehaviour from '../../src/addToWishlist'
import { trackListingViewed } from '../../analytics/events/browsing'
import setMaskedUrls from '../../src/maskedUrls'
import initListingCarousel from '../../src/listingCarousel'
import initProductTabs from '../../src/productTabs'

document.addEventListener('DOMContentLoaded', () => {
  initRelatedListingsModules()
  initDeliverySection()
  initfixedDeliverySection()
  initPDPFomoStats()
  setUpMakeAnOffer()
  setUpMakeAnOfferOld()
  updateUserSpecificSections()
  setUpAddToWishlistBehaviour()
  trackListingViewed()
  setMaskedUrls()
  initListingCarousel()
  initProductTabs()
})
